<template>
  <section class="relative overflow-hidden bg-navy-50/60">
    <!-- soft background wash -->
    <div class="pointer-events-none absolute -right-40 -top-40 h-[34rem] w-[34rem] rounded-full bg-sky-200/50 blur-3xl"></div>
    <div class="pointer-events-none absolute -bottom-52 -left-32 h-[30rem] w-[30rem] rounded-full bg-sky-100/70 blur-3xl"></div>

    <div class="relative mx-auto grid max-w-7xl items-center gap-14 px-5 py-16 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:px-8 lg:py-24">
      <div>
        <p class="inline-flex items-center gap-2 rounded-full border border-navy-200 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-navy-700 shadow-sm">
          <span class="h-1.5 w-1.5 rounded-full bg-sky-400"></span>
          Bishop's Stortford · Free quotes
        </p>

        <h1 class="mt-7 text-[2.6rem] font-extrabold leading-[1.05] tracking-tight text-navy-950 sm:text-6xl lg:text-[4.1rem]">
          Your property,<br />
          <span class="text-navy-500">properly clean.</span>
        </h1>

        <p class="mt-6 max-w-xl text-lg leading-8 text-navy-700">
          We clean roofs, render, gutters, windows, driveways and patios for homes and businesses in
          Bishop's Stortford and the surrounding area. Years of dirt, moss and algae washed off, and the
          site left tidy when we go.
        </p>

        <div class="mt-9 flex flex-col gap-3 sm:flex-row">
          <a href="#contact" class="btn-primary">
            Get a free quote
            <i class="fas fa-arrow-right text-xs"></i>
          </a>
          <a href="#work" class="btn-ghost">See before &amp; after</a>
        </div>

        <dl class="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-navy-200/70 pt-8">
          <div v-for="stat in stats" :key="stat.label">
            <dt class="text-2xl font-extrabold text-navy-950 sm:text-3xl">{{ stat.value }}</dt>
            <dd class="mt-1 text-xs font-medium leading-5 text-navy-600 sm:text-sm">{{ stat.label }}</dd>
          </div>
        </dl>
      </div>

      <!-- image composition -->
      <div class="relative">
        <div class="overflow-hidden rounded-[1.75rem] shadow-lift ring-1 ring-navy-900/5">
          <img
            src="../assets/power-washing.jpg"
            alt="Operative pressure washing a driveway"
            class="h-[22rem] w-full object-cover sm:h-[30rem] lg:h-[34rem]"
          />
        </div>

        <div class="absolute -bottom-6 -left-4 hidden w-64 rounded-2xl border border-navy-100 bg-white p-5 shadow-lift sm:block lg:-left-10">
          <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-navy-50 text-navy-700 ring-1 ring-navy-100">
            <i class="fas fa-shield-halved"></i>
          </span>
          <p class="mt-3 text-sm font-bold leading-6 text-navy-950">Fully insured, method-matched cleaning</p>
          <p class="mt-1 text-xs font-medium leading-5 text-navy-500">Pure water, low pressure or rotary. Whatever the surface needs.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const stats = [
  { value: '10+', label: 'Exterior services' },
  { value: 'Insured', label: 'Fully insured work' },
  { value: 'Free', label: 'No-obligation quotes' }
]
</script>
